import { NavLink } from 'react-router-dom'
import { NavCta, NavLinkItem } from '../../../types/navigation'

interface DeskNavProps {
	navLinks: NavLinkItem[]
	currentPageCTA?: NavCta
	className: string
}

const DeskNav = ({ navLinks, currentPageCTA, className }: DeskNavProps) => {
	return (
		<nav className={`${className} items-center gap-7`} aria-label="Main">
			{navLinks.map((navLink) => (
				<NavLink
					key={navLink.to}
					to={navLink.to}
					className={({ isActive }) =>
						isActive
							? 'border-b-2 border-accent pb-0.5 text-sm font-semibold text-slate-900'
							: 'text-sm text-slate-500 transition-colors hover:text-slate-900'
					}
				>
					{navLink.name}
				</NavLink>
			))}

			{currentPageCTA && (
				<a href={currentPageCTA.href} className="btn-accent px-5 py-2.5 text-sm">
					{currentPageCTA.text}
				</a>
			)}
		</nav>
	)
}

export default DeskNav
